import {
    CREATEOPERATION,
    GETOPERATION,
    UPDATEOPERATION,
    DELETEOPERATION,
    CREATEOPERATIONCATEGORY,
    GETOPERATIONCATEGORY,
    UPDATEOPERATIONCATEGORY,
    DELETEOPERATIONCATEGORY,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEOPERATION:
            return {
                ...state,
                operationSaveStatus: action.payload.success,
            }
        case GETOPERATION:
                return {
                        ...state,
                        operationList: action.payload.data,
                        }
        case UPDATEOPERATION:
                return {
                        ...state,
                        operationUpdateStatus: action.payload.success,
                        }   

        case DELETEOPERATION:
                 return {
                     ...state,
                     operationDeleteStatus: action.payload.success,
                        } 
        case CREATEOPERATIONCATEGORY:
            return {
                ...state,
                operationcategorySaveStatus: action.payload.success,
            }
        case GETOPERATIONCATEGORY:
                return {
                        ...state,
                        operationcategoryList: action.payload.data,
                        }
        case UPDATEOPERATIONCATEGORY:
                return {
                        ...state,
                        operationcategoryUpdateStatus: action.payload.success,
                        }   

        case DELETEOPERATIONCATEGORY:
                 return {
                     ...state,
                     operationcategoryDeleteStatus: action.payload.success,
                        } 
        default:
                return state
                      }
                 }